import { apiEnvironment } from '../smoothr-web-app-core/environments/apiEnvironment';

export const customerGroup = 'wyniger';

const supportEmail = {
	[customerGroup]: `${customerGroup}@smoothr.de`,
};
const firebaseConfig = {
	[customerGroup]: {
		apiKey: 'AIzaSyDJtPJYGpl99SedNgx8ru44SMBm9Cfvx3k',
		authDomain: 'wyniger-6c083.firebaseapp.com',
		projectId: 'wyniger-6c083',
		storageBucket: 'wyniger-6c083.firebasestorage.app',
		messagingSenderId: '165909436914',
		appId: '1:165909436914:web:82a240366ca147334df36b',
	},
};
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyDx99_I34aUK3cLhF7zTI6Uxcq6FP9qKvA',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	firebaseConfig: firebaseConfig[customerGroup],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup + '-dev',
	...apiEnvironment,
	countryList: ['ch'],
	gaId: '',
	facebookPixelId: '268622425330452',
	hasRecommendations: true,
	apiUrl: 'https://dev-dean-and-david.smoothr.de/',
	location: '',
	deactivateDelivery: false,
	enableCashPayment: false,
	allowNavigationToWorldline: false,
	urlQrCode: 'smoothr://',
	defVenue: '685cb4a29ee8ab5cafda5c7c',
	merchantId: '1110017883',
	merchantGoogleId: '123123123',
};

import 'zone.js';
